import { render } from "./PeriodDashboard.vue?vue&type=template&id=de651584"
import script from "./PeriodDashboard.vue?vue&type=script&lang=js"
export * from "./PeriodDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script